import React, {useEffect, useState} from 'react';
import {
  DefaultPaginationValues,
  queryString,
} from '../../../Util/commonUtility';
import SponsorsComponent from '../../../Components/AdminComponents/Sponsors';
import {useDispatch, useSelector} from 'react-redux';
import {getAllSponsorsByQuery} from '../../../Store/Actions';
import {
  UpdateSponsorById,
  cancelEventRegistrationsByEventIds,
  deleteToBePaidRegistration as deleteToBePaidRegistrationAction,
  updateFoodAndRegistrationOptions,
} from '../../../Store/Actions/eventRegister';
import {setPageNumber, setPageSize} from '../../../Store/Actions/pageSize';

const SponsorsContainer = () => {
  const dispatch = useDispatch();
  const {allSponsorsQueryData} = useSelector(({sponsors}) => sponsors);
  const [listData, setListData] = useState();
  const memorizedPageNumber = useSelector(
    ({pageSizes}) => pageSizes.pageNumbers.sponsors,
  );
  const memorizedPageSize = useSelector(
    ({pageSizes}) => pageSizes.pageSizes.sponsors,
  );
  const [pagination, setPagination] = useState({
    page: memorizedPageNumber || DefaultPaginationValues.PAGE,
    pageCount: memorizedPageSize || DefaultPaginationValues.PAGE_SIZE,
    totalPages: DefaultPaginationValues.TOTAL_PAGES,
  });
  const [sortParams, setSortParams] = useState({
    field: 'id',
    order: 'descend',
  });
  const [paginationAndSortChanged, setPaginationAndSortChanged] =
    useState(false);
  const searchValues = useSelector(
    ({dynamicSearch}) => dynamicSearch.searchValues.sponsors,
  );

  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [totalDiscountedAmount, setTotalDiscountedAmount] = useState(0);
  const [totalCreditAmount, setTotalCreditAmount] = useState(0);
  const [totalRefundAmount, setTotalRefundAmount] = useState(0);

  useEffect(() => {
    if (allSponsorsQueryData) {
      setListData(allSponsorsQueryData?.data?.sponsors);
      setPagination({
        ...pagination,
        page: allSponsorsQueryData?.data?.currentPage,
        totalPages: allSponsorsQueryData?.data?.totalPage,
        totalCount: allSponsorsQueryData?.data?.totalCount,
      });
      setTotalPaidAmount(allSponsorsQueryData?.data?.total_paid_amount || 0);
      setTotalCreditAmount(
        allSponsorsQueryData?.data?.total_credit_amount || 0,
      );
      setTotalDiscountedAmount(
        allSponsorsQueryData?.data?.total_discount_amount || 0,
      );
      setTotalRefundAmount(
        allSponsorsQueryData?.data?.total_refund_amount || 0,
      );
    } else {
      // Reducer clears allSponsorsQueryData on delete/update/create; refetch must keep filters.
      fetchSponsor(searchValues);
    }
  }, [allSponsorsQueryData]);

  useEffect(() => {
    if (paginationAndSortChanged) {
      fetchSponsor(searchValues);
      setPaginationAndSortChanged(false);
    }
  }, [paginationAndSortChanged, searchValues]);

  useEffect(() => {
    if (searchValues) {
      dispatch(setPageNumber('sponsors', 1));
      setPagination({
        ...pagination,
        page: 1,
      });
      setPaginationAndSortChanged(true);
    }
  }, [searchValues]);

  const handleTableChange = (pagination, filter, sorter) => {
    setSortParams({
      field: sorter.field,
      order: sorter.order,
    });
    setPaginationAndSortChanged(true);
  };
  const handlePaginationChange = (current, pageSize) => {
    dispatch(setPageSize('sponsors', pageSize));
    dispatch(setPageNumber('sponsors', current));

    setPagination({
      ...pagination,
      page: current,
      pageCount: pageSize,
    });
    setPaginationAndSortChanged(true);
  };
  const fetchSponsor = async (searchValues) => {
    const sortField = sortParams.field || '';
    const sortOrder = sortParams.order || '';
    const searchQueryData = queryString(searchValues);
    dispatch(
      getAllSponsorsByQuery(sortField, sortOrder, searchQueryData, pagination),
    );
  };

  const UpdateRegistrationOptions = (data, id, setEditingKey) => {
    return dispatch(
      updateFoodAndRegistrationOptions(
        data,
        id,
        setEditingKey,
        undefined,
        undefined,
        undefined,
        undefined,
        () => fetchSponsor(searchValues),
      ),
    );
  };

  const cancelEventRegistrations = async (eventIds, setSelectedRowKeys) => {
    const result = await dispatch(
      cancelEventRegistrationsByEventIds(eventIds, setSelectedRowKeys),
    );
    fetchSponsor(searchValues);
    return result;
  };

  const deleteToBePaidRegistration = (registrationId, onSuccess) => {
    dispatch(deleteToBePaidRegistrationAction(registrationId, onSuccess));
  };

  const updateSponsorAssets = (
    formData,
    eventRegistrationId,
    onSuccess,
    onError,
  ) => {
    dispatch(
      UpdateSponsorById(
        formData,
        eventRegistrationId,
        null,
        () => {
          fetchSponsor(searchValues);
          onSuccess && onSuccess();
        },
        onError,
      ),
    );
  };

  return (
    <div>
      <SponsorsComponent
        allSponsorData={listData}
        paging={pagination}
        handlePaginationChange={(page, pageSize) => {
          handlePaginationChange(page, pageSize);
        }}
        handleTableChange={handleTableChange}
        fetchSponsor={(searchValues) => {
          fetchSponsor(searchValues);
        }}
        sortParams={sortParams}
        searchValues={searchValues}
        totalPaidAmount={totalPaidAmount}
        totalDiscountedAmount={totalDiscountedAmount}
        totalCreditAmount={totalCreditAmount}
        totalRefundAmount={totalRefundAmount}
        UpdateRegistrationOptions={(data, id, setEditingKey) =>
          UpdateRegistrationOptions(data, id, setEditingKey)
        }
        cancelEventRegistrations={cancelEventRegistrations}
        deleteToBePaidRegistration={(registrationId, onSuccess) => {
          deleteToBePaidRegistration(registrationId, onSuccess);
        }}
        updateSponsorAssets={(
          formData,
          eventRegistrationId,
          onSuccess,
          onError,
        ) => {
          updateSponsorAssets(
            formData,
            eventRegistrationId,
            onSuccess,
            onError,
          );
        }}
      />
    </div>
  );
};
export default SponsorsContainer;
